import { motion } from "framer-motion";

const Partners = ({ partners }) => {
  // Double the partners array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section
      id="partners"
      className="py-20 bg-slate-50"
      data-testid="partners-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="gold-accent mx-auto mb-6" />
          <h2 className="text-3xl sm:text-4xl font-bold text-navy mb-4 font-serif">
            Our Carrier Partners
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            We work with the industry's most trusted insurance carriers to bring
            you the best products and rates.
          </p>
        </motion.div>

        {/* Marquee Container */}
        <div className="marquee-container py-8">
          <div className="flex animate-marquee">
            {duplicatedPartners.map((partner, index) => (
              <div
                key={`${partner.id}-${index}`}
                className="flex-shrink-0 mx-8"
                data-testid={`partner-${partner.id}`}
              >
                <div className="bg-white rounded-xl px-8 py-6 shadow-sm border border-slate-100 min-w-[200px] text-center hover:shadow-md transition-shadow duration-300">
                  <span className="text-xl font-semibold text-navy">
                    {partner.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Indicators */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-wrap justify-center gap-8 mt-12"
        >
          {[
            { label: "A-Rated Carriers", value: "100%" },
            { label: "Combined Assets", value: "$500B+" },
            { label: "Years in Market", value: "50+" },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl font-bold text-amber-600">{stat.value}</div>
              <div className="text-sm text-slate-600">{stat.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Partners;
